<template>
    <div class="list-top">
        <p class="title">课件平台</p>
        <div class="btns-box">
            <p v-if="$route.query.id && isBack" class="back" @click="back">返回</p>
            <!--<p v-if="$route.query.fromPlat!=='window'" class="quit" @click="quit">退出</p>-->
        </div>
    </div>
</template>

<script>
    export default {
        name: "list-top",
        props: {
            isBack: Boolean
        },
        methods: {
            back(){
                this.$RouteUtil.main({...this.$route.query})
            },
            quit(){
                window.close()
            }
        }
    }
</script>

<style lang="scss" scoped>
.list-top{
    display: flex;
    height: 54px;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0px 16px;
    border-bottom: 2px solid #F3F5F5;

    .title{
        font-size:18px;
        font-weight:500;
        color:rgba(48,49,51,1);
        line-height:25px;
    }

    .btns-box{
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size:14px;
        font-weight:400;
        color:rgba(48,49,51,1);
        line-height:20px;

        .back, .quit{
            margin: 0px 16px;
            cursor: pointer;

            &:hover {
                color: #e7622e;
            }
        }
    }
}
</style>
